import React from 'react';
import { useDraggable } from '@dnd-kit/core';

type DraggableItemProps = {
  id: string;
  children: React.ReactNode;
  containerId?: string,
}

export const DraggableItem: React.FC<DraggableItemProps> = ({ id, containerId, children }) => {
  const {
    attributes,
    listeners,
    setNodeRef,
  } = useDraggable({
    id,
    data: {
      containerId
    }
  });

  const style = {
    backgroundColor: 'white',
    margin: '8px 0',
    border: '1px solid #ddd',
    borderRadius: '4px',
    cursor: 'grab',
    touchAction: 'none',
  };

  return (
    <div
      ref={setNodeRef}
      style={style}
      {...listeners}
      {...attributes}
    >
      {children}
    </div>
  );
};